export enum RecurrenceUpdateType {
  UpdateSingleEvent,
  UpdateEntireSeries,
  UpdateSeriesForward,
}
